// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminPage_container__3L4sG","text":"AdminPage_text__bwoIv","contentContainer":"AdminPage_contentContainer__3HpYQ"};